import { yyyy, zzzz } from "../../store.svelte";
const uri: string = yyyy.uri.api;

// export default (url, ResourceType) => {
// 	const tileHead = new Headers();
// 	tileHead.append("Accept", "application/octet-stream");
// 	//console.log("url", url, "restype", ResourceType);
// 	//console.log("this is: ", yyyy.uri.api);
//
// 	if (url.startsWith("/rpc/")) {
// 		// console.log("old: ", url, " new : ", yyyy.uri.api + url);
// 		return {
// 			url: yyyy.uri.api + url,
// 			headers: {
// 				Accept: "application/octet-stream",
// 				Authorization: "Bearer " + yyyy.sesh.logtoken.token,
// 			},
// 		};
// 	}
//
// 	return { url: url };
// };

export default (url, ResourceType) => {
	if (url.startsWith("/rpc/")) {
		const urlObj = new URL(url, yyyy.uri.api);
		const isTiles = urlObj.pathname.endsWith("/rpc/tiles");

		if (isTiles) {
			const body = Object.fromEntries(urlObj.searchParams.entries());
			// Convert numeric params
			["z", "x", "y"].forEach(k => {
				if (body[k]) body[k] = Number(body[k]);
			});

			return {
				url: yyyy.uri.api + urlObj.pathname,
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/octet-stream",
					Authorization: "Bearer " + yyyy.sesh.logtoken.token,
				},
				body: JSON.stringify(body),
			};
		}

		return {
			url: yyyy.uri.api + url,
			headers: {
				Accept: "application/octet-stream",
				Authorization: "Bearer " + yyyy.sesh.logtoken.token,
			},
		};
	}
	return { url: url };
};
